import Vue from 'vue';

// eslint-disable-next-line no-unused-vars
export default function openDialog({ stationVipPriceHistoryList }) {
  const vm = new Vue({
    data() {
      return {
        show: true,
        beforeCancel: () => {
          this.$destroy();
        },
        columns: [
          {
            label: '类别名称',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row }) => {
                const { feeType } = row;
                const feeTypeMap = {
                  1: '尖',
                  2: '峰',
                  3: '平',
                  4: '谷',
                };
                return feeTypeMap[feeType] || '——';
              },
            },
          },
          {
            label: '会员卡服务费',
            scopedSlots: {
              default: ({ row: { vipServiceRate } }) => `${vipServiceRate || '——'}元/度`,
            },
          },
          {
            label: '兜底服务费',
            scopedSlots: {
              default: ({ row: { ensureServiceRate } }) => `${ensureServiceRate || '——'}元/度`,
            },
          },
        ],
      };
    },
    beforeDestroy() {
      this.show = false;
      document.body.removeChild(this.$el);
    },
    render() {
      const { show, columns } = this;
      const title = `价格详情`;
      return (
        <YkcOperationDialog
          show={show}
          title={title}
          showCancelButton={false}
          beforeCancel={this.beforeCancel}
          vOn:close-dialog={this.beforeCancel}>
          <template slot="content">
            {/* 由于jsx限制，这里需要显式通过props传递 */}
            <ykc-table data={stationVipPriceHistoryList || []} columns={columns}></ykc-table>
          </template>
        </YkcOperationDialog>
      );
    },
  });
  vm.$mount();
  document.body.appendChild(vm.$el);
}
